const isLocal = process.env.NODE_ENV === "development"
const isProductionServer = true

export const appVersion = "v1.0.0.1"

export const baseUrl = isProductionServer ? (
    "https://rest.mydesk.dk/api" // Prod
) : ("https://rest.mydesk-test.dk/api") // Test
export const clientId = isProductionServer ? (
    "ac2195a2-2960-452d-9cb9-ad6e9dfa9e16" // Prod
) : ("dfc7a5bf-7579-4edc-8a76-905bec3ed840") // Test
export const scope = isProductionServer ? (
    "https://portlr.onmicrosoft.com/user_impersonation" // Prod
) : ("https://portlr.onmicrosoft.com/test/user_impersonation") // Test
export const seatBaseUrl = isProductionServer ? (
    "https://bluedock.mydesk.dk/Home/CheckIn" // Prod
) : ("https://mydesk-test.dk/Home/CheckIn") // Test
export const meetingRoomBaseUrl = isProductionServer ? (
    "https://bluedock.mydesk.dk/MeetingRoom" // Prod
) : ("https://mydesk-test.dk/MeetingRoom") // Test

export const localStorageNames = {
    tokenName: "token",
    printerName: "printerName",
}

// Create Shade of #Hex color (divide = 2)
export const getShadeOfColor = (hex, divide) => {
    // Converted #Hex to (R, G, B)
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)

    // Convert (R, G, B) to their respective shades
    const r2 = parseInt(`${r + (255 - r) / divide}`)
    const g2 = parseInt(`${g + (255 - g) / divide}`)
    const b2 = parseInt(`${b + (255 - b) / divide}`)

    // Convert (R, G, B) to (R => #Hex, B => #Hex, G => #Hex)
    const toHex = (c) => {
        var hex = c.toString(16)
        return hex.length === 1 ? "0" + hex : hex
    }

    return "#" + toHex(r2) + toHex(g2) + toHex(b2)
}

export const setThemeColors = (Theme) => {
    if (Theme && Object.keys(Theme)?.length > 0) {
        const root = document.querySelector(":root")
        if (root) {
            const { AppThemeColor } = Theme

            root?.style?.setProperty("--app-theme-color", `#${AppThemeColor}`)
            root?.style?.setProperty("--app-theme-50-color", getShadeOfColor(`#${AppThemeColor}`, 1.3))
            root?.style?.setProperty("--app-theme-30-color", getShadeOfColor(`#${AppThemeColor}`, 1.8))
            root?.style?.setProperty("--app-theme-25-color", getShadeOfColor(getShadeOfColor(`#${AppThemeColor}`, 1.3), 2))
            root?.style?.setProperty("--app-theme-10-color", getShadeOfColor(getShadeOfColor(getShadeOfColor(`#${AppThemeColor}`, 1.3), 2), 2))
        }
    } else {
        setThemeColors({ AppThemeColor: "6D66D1" })
    }
}